export type Sluggable = { slug?: string };

export function getSlug(item: Sluggable): string {
  return item.slug || '---';
}
